import ShareByEmailModal from './share-by-email-modal'

export default ShareByEmailModal
